/* fk-bottom-nav.js — Fotouh AlKuwait mobile bottom navigation + mobile header search */
(function () {
  'use strict';

  var S    = window.fkShop || {};
  var AR   = (S.locale === 'ar');
  var HOME = S.homeUrl || '/';

  var TX = {
    home:   { en: 'Home',       ar: '\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629' },
    cats:   { en: 'Categories', ar: '\u0627\u0644\u0641\u0626\u0627\u062A' },
    acct:   { en: 'Account',    ar: '\u062D\u0633\u0627\u0628\u064A' },
    cart:   { en: 'Cart',       ar: '\u0627\u0644\u0633\u0644\u0629' },
    search: { en: 'Search',     ar: '\u0628\u062D\u062B' },
    searchPh: { en: 'Search...', ar: '\u0628\u062D\u062B...' }
  };
  function t(k) { return AR ? TX[k].ar : TX[k].en; }

  var CATS_PATH = '/pages/collections-overview';
  var catsUrl   = AR ? '/ar' + CATS_PATH : CATS_PATH;
  var acctUrl   = S.accountUrl || '/account';
  var acctMounted = false;

  var IC = {
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5L12 3l9 7.5"/><path d="M5 9.5V21h5v-6h4v6h5V9.5"/></svg>',
    cats: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="8" cy="8" r="3.2"/><circle cx="16" cy="8" r="3.2"/><circle cx="8" cy="16" r="3.2"/><circle cx="16" cy="16" r="3.2"/></svg>',
    acct: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    searchW: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>'
  };

  function basePath() {
    var p = location.pathname.replace(/^\/ar(?=\/|$)/, '');
    return p === '' ? '/' : p;
  }

  function isActive(which) {
    var p = basePath();
    if (which === 'home') return p === '/';
    if (which === 'cats') return p.indexOf(CATS_PATH) === 0 || p.indexOf('/collections') === 0;
    if (which === 'acct') return p.indexOf('/account') === 0;
    return false;
  }

  function linkItem(which, url) {
    var on = isActive(which) ? ' fk-bn-on' : '';
    return '<a class="fk-bn-item' + on + '" href="' + url + '">' +
             '<span class="fk-bn-iconwrap">' + IC[which] + '</span>' +
             '<span class="fk-bn-label">' + t(which) + '</span>' +
           '</a>';
  }

  function setBadge(n) {
    var b = document.getElementById('fk-bn-badge');
    if (!b) return;
    n = parseInt(n, 10) || 0;
    b.textContent = n;
    b.style.display = n > 0 ? 'flex' : 'none';
  }

  function syncBadge() {
    var src = document.getElementById('fk-badge');
    if (src) {
      setBadge(src.textContent);
      var mo = new MutationObserver(function () { setBadge(src.textContent); });
      mo.observe(src, { childList: true, characterData: true, subtree: true });
    } else {
      var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setBadge(c.item_count); }).catch(function () {});
    }
  }

  function cartIsOpen() {
    var dr = document.getElementById('fk-cart-drawer');
    return !!(dr && dr.classList.contains('on'));
  }

  function build() {
    if (document.getElementById('fk-bottom-nav')) return;
    var nav = document.createElement('nav');
    nav.id = 'fk-bottom-nav';
    nav.setAttribute('aria-label', 'Mobile navigation');
    var acctOn = isActive('acct') ? ' fk-bn-on' : '';
    nav.innerHTML =
      linkItem('home', HOME) +
      linkItem('cats', catsUrl) +
      '<div class="fk-bn-item fk-bn-acct-host' + acctOn + '" id="fk-bn-acct">' +
        '<span class="fk-bn-iconwrap" id="fk-bn-acct-iconwrap">' + IC.acct + '</span>' +
        '<span class="fk-bn-label">' + t('acct') + '</span>' +
      '</div>' +
      '<button type="button" class="fk-bn-item" id="fk-bn-cart" aria-label="' + t('cart') + '">' +
        '<span class="fk-bn-iconwrap">' + IC.cart + '<span class="fk-bn-badge" id="fk-bn-badge" style="display:none">0</span></span>' +
        '<span class="fk-bn-label">' + t('cart') + '</span>' +
      '</button>';
    document.body.appendChild(nav);

    /* Fallback only: if the real account component never mounts, tapping
       the tab navigates to the account page instead of doing nothing. */
    document.getElementById('fk-bn-acct').addEventListener('click', function () {
      if (acctMounted) return; /* the real cloned component already handled the tap */
      if (cartIsOpen() && window.fkCart && window.fkCart.close) window.fkCart.close();
      var url = acctUrl;
      if (AR && url.charAt(0) === '/' && url.indexOf('/ar') !== 0) url = '/ar' + url;
      window.location.href = url;
    });

    /* cart tab toggles the drawer: open it if closed, close it if open */
    document.getElementById('fk-bn-cart').addEventListener('click', function () {
      if (!window.fkCart) return;
      if (cartIsOpen()) {
        if (window.fkCart.close) window.fkCart.close();
      } else {
        if (window.fkCart.open) window.fkCart.open();
      }
    });

    syncBadge();
  }

  /* ---- Account tab: real, independent copy of the header's <shopify-account> ----
     We don't move or simulate-click the header's component (that left it broken
     and unreliable). We clone it — the browser instantiates a fresh, fully real
     instance of the same native component, so tapping it behaves identically to
     the header, with no risk to the header's own copy. */
  function mountAccountInTab(tries) {
    tries = tries || 0;
    var header = document.querySelector('#fk-acct-wrap shopify-account') || document.querySelector('shopify-account');
    if (!header) {
      if (tries > 30) return; /* ~3s give-up; tab still falls back to navigation */
      setTimeout(function () { mountAccountInTab(tries + 1); }, 100);
      return;
    }
    var iconwrap = document.getElementById('fk-bn-acct-iconwrap');
    if (!iconwrap || iconwrap.querySelector('shopify-account')) return;
    var clone = header.cloneNode(true);
    iconwrap.innerHTML = '';
    iconwrap.appendChild(clone);
    acctMounted = true;
  }

  /* ---- Mobile header search: magnifier button + expandable row ---- */
  function buildMobileSearch() {
    var headerNav = document.getElementById('fk-nav');
    var btnRow = document.getElementById('fk-nav-btns');
    if (!headerNav || !btnRow || document.getElementById('fk-msearch')) return;

    var sb = document.createElement('button');
    sb.type = 'button';
    sb.id = 'fk-msearch';
    sb.setAttribute('aria-label', t('search'));
    sb.innerHTML = IC.search;
    btnRow.insertBefore(sb, btnRow.firstChild);

    var row = document.createElement('div');
    row.id = 'fk-msearch-row';
    row.innerHTML =
      '<div class="fk-search">' +
        '<input type="text" id="fk-msi" placeholder="' + t('searchPh') + '" aria-label="' + t('search') + '">' +
        '<button type="button" class="fk-search-btn" id="fk-msbtn" aria-label="' + t('search') + '">' + IC.searchW + '</button>' +
      '</div>';
    headerNav.appendChild(row);

    var input = document.getElementById('fk-msi');

    function closeRow() {
      if (row.classList.contains('open')) {
        row.classList.remove('open');
        if (input) input.blur();
      }
    }

    function go() {
      var q = (input ? input.value : '').trim();
      if (q) location.href = (S.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(q);
    }

    sb.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = row.classList.toggle('open');
      /* focus SYNCHRONOUSLY inside the tap gesture — iOS only shows the
         keyboard for focus() calls made directly within a user gesture;
         a delayed (setTimeout) focus is silently ignored */
      if (open && input) {
        input.focus();
      } else if (input) {
        input.blur();
      }
    });
    document.getElementById('fk-msbtn').addEventListener('click', go);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') go(); });

    /* close when tapping/touching anywhere outside the search row or the magnifier */
    function outside(e) {
      if (!e.target.closest('#fk-msearch-row') && !e.target.closest('#fk-msearch')) closeRow();
    }
    document.addEventListener('click', outside);
    document.addEventListener('touchstart', outside, { passive: true });

    /* close only on a REAL finger drag (touchmove), not on 'scroll' events —
       iOS fires scroll events when the keyboard opens or the page auto-zooms,
       and a scroll-based close was blurring the input and killing the keyboard */
    window.addEventListener('touchmove', function (e) {
      if (e.target && e.target.closest && e.target.closest('#fk-msearch-row')) return;
      closeRow();
    }, { passive: true });
  }

  /* ---- hide header on scroll down, reveal on scroll up ---- */
  function buildHeaderHide() {
    var lastY = window.scrollY || 0;
    var acc = 0; /* accumulated scroll in the current direction */
    window.addEventListener('scroll', function () {
      var y = window.scrollY || 0;
      var d = y - lastY;
      lastY = y;
      if (y < 80) {
        document.documentElement.classList.remove('fk-hh');
        acc = 0;
        return;
      }
      acc = ((d > 0) === (acc > 0)) ? acc + d : d;
      if (acc > 28) {
        document.documentElement.classList.add('fk-hh');
      } else if (acc < -28) {
        document.documentElement.classList.remove('fk-hh');
      }
    }, { passive: true });
  }

  /* Each step is isolated: if one throws, the others still run.
     This is what guarantees search can never be taken down by a bug
     in the account logic again. */
  function init() {
    try { build(); } catch (e) { if (window.console) console.error('[fk-bn] build failed', e); }
    try { buildMobileSearch(); } catch (e) { if (window.console) console.error('[fk-bn] search failed', e); }
    try { buildHeaderHide(); } catch (e) { if (window.console) console.error('[fk-bn] header-hide failed', e); }
    try { mountAccountInTab(0); } catch (e) { if (window.console) console.error('[fk-bn] account mount failed', e); }
  }

  /* exposed for fk-nav.js so active tabs refresh after in-place navigation */
  window.fkBottomNav = {
    refresh: function () {
      var n = document.getElementById('fk-bottom-nav');
      if (n && n.parentNode) n.parentNode.removeChild(n);
      acctMounted = false;
      try { init(); } catch (e) {}
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
